import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Alert } from "react-bootstrap";
import {
    resetAllQueuesFromAWSForCadTopology,
    GetAwsQueuesFromConfig
  } from "../../../UserFunctions";
import PropTypes from "prop-types";


function ResetQueueConfirmation(props) {
    const [ userInput, setUserInput ] = useState('');
    const [ resetQueueConfirmError, setResetQueueConfirm ] = useState('');
    const [awsQueues, setawsQueues] = useState([]);
    const [inputString, setInputString] = useState(false);

    const handleSubmit = (e) => {
        console.log(userInput)
        e.preventDefault();
        if(userInput === "purge"){
            GetAwsQueuesFromConfig("/get_aws_queues").then((response) => {
                console.log(awsQueues)
                setawsQueues(response.data.queues);
                setInputString(false)
                setResetQueueConfirm('')
                for (var i = 0; i < response.data.queues.length; i++) {
                var payload = {
                    queue_name: response.data.queues[i],
                };
                resetAllQueuesFromAWSForCadTopology(
                    "/aws/sqs/remove_messages",
                    payload
                ).then((res) => {
                    console.log("res", res)
                    props.setClose();
                }).catch(error => {
                    setResetQueueConfirm(error.response.data.message)
                });
                }
            }).catch(error => {
                setResetQueueConfirm(error.response.data.message)
            });            
        }
        else{
            setInputString(true)
            e.preventDefault();
            setawsQueues([])
        }   
    }

    return (
        <>
            <Modal
                size="sm"
                show={props.show}
                onHide={() => props.setClose()}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Reset Queues?</Modal.Title>
                </Modal.Header>
                {resetQueueConfirmError? 
                    <Alert key="danger" variant="danger">
                        {resetQueueConfirmError}
                    </Alert> : null}
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group>
                            <Form.Label>Purge Queues</Form.Label>
                            <Form.Control
                                type='text'
                                required
                                value={userInput}
                                onChange={(e) => setUserInput(e.target.value.toLowerCase())}
                                placeholder='purge'
                                autoFocus
                            />
                            {inputString ? (<Form.Text style={{ backgroundColor: "red" }}>
                                    Incorrect text 
                                </Form.Text>) : undefined}
                            <Form.Text>
                                Please type <strong>purge</strong> to confirm and purge all
                                configured queues.
                            </Form.Text>
                        </Form.Group>
                        <Button
                            style={{backgroundColor: "#757AF7"}}
                            type='submit'
                        >
                            Confirm
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

ResetQueueConfirmation.propTypes = {
    setClose: PropTypes.func,    
    show: PropTypes.bool,
};

export default ResetQueueConfirmation;